import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from 'src/environments/environment';

import { DeviceDetectorService } from 'ngx-device-detector';

import { ImgFallbackModule } from 'ngx-img-fallback';

@Component({
  selector: 'app-user-image',
  standalone: true,
  imports: [CommonModule, ImgFallbackModule],
  template: `
    <img
      [src]="imgSrc"
      src-fallback="{{ defaultAvatarImg }}"
      [height]="height"
      [width]="width"
      [ngClass]="{ avatar: isAvatar }"
      (click)="onAvatarClick()"
    />
  `,
  styles: [
    `
      .avatar {
        border-radius: 50%;
        cursor: pointer;
      }
    `,
  ],
})
export class UserImageComponent {
  defaultAvatarImg = '/assets/default-avatar.png';
  _imgSrc: string | undefined | null;
  get imgSrc(): string | undefined | null {
    if (!this._imgSrc || this._imgSrc === 'no-image') {
      return this.defaultAvatarImg;
    }

    return this._imgSrc;
  }
  @Input() set imgSrc(value: string | undefined | null) {
    this._imgSrc = value;
  }

  @Input() userId!: string;
  @Input() width!: number;
  @Input() height!: number;
  @Input() isAvatar = false;

  @Output() avatarClick = new EventEmitter<string>();

  constructor(private deviceService: DeviceDetectorService) {}

  onAvatarClick() {
    if (!this.isAvatar) {
      return;
    }

    const appProfileUrl = environment.shareProfile.getLink(this.userId);

    // Non mobile device should not navigate to the url as this requires the mobile app
    if (!this.deviceService.isMobile()) {
      this.avatarClick.emit(appProfileUrl);
      return;
    }

    window.open(appProfileUrl, '_blank');
  }
}
